export interface SurveyAddonAlert {
    yourAnswer: string;
    required: string;
    amount: string;
    matrixAmount: string;
    numRange: string;
    fileMaxSize: string;
    fileExt: string;
    fileMaxAmount: string;
    comment: string;
    email: string;
    datetime: string;
    distribution: string;
    phone: string;
    indicator: string;
    inputTextLength: string;
    firstClickImage: string;
    cardSortingText: string;
    cardSortingCardsText: string;
    cardSortingNewCategoryText: string;
    cardSortedText: string;
    cardSortingCategoryNameText: string;
    cardSortingNoCategoryAvailableText: string;
    cardSortingNoCardsText: string;
    pairComparisonCompleteText: string;
    pairComparisonPairsText: string;
    maxDiffBlock: string;
    kanoRow: string;
    videoTestText: string;
    fiveSecTestImageText: string;
    fiveSecTestText: string;
    figmaLoadingText: string;
    figmaErrorText: string;
    figmaNoDataText: string;
    figmaScreenNotFoundText: string;
    figmaPrototypeUnavailableText: string;
    figmaStartTitle: string;
    figmaStartInstruction: string;
    figmaStartInstructionScreen: string;
    figmaStartInstructionAudio: string;
    figmaStartInstructionCamera: string;
    figmaStartInstructionScreenAudio: string;
    figmaStartInstructionScreenCamera: string;
    figmaStartInstructionAudioCamera: string;
    figmaStartInstructionScreenAudioCamera: string;
    figmaStartButton: string;
    figmaStartButtonRequesting: string;
    figmaPermissionsError: string;
    figmaPermissionsManualText: string;
    figmaTimerLabel: string;
    figmaSurrenderButton: string;
    figmaCompleteButton: string;
    figmaCompletionSuccessTitle: string;
    figmaCompletionSuccessText: string;
    figmaCompletionSurrenderTitle: string;
    figmaCompletionSurrenderText: string;
    figmaCompletionTimeoutTitle: string;
    figmaCompletionTimeoutText: string;
    figmaCompletionCompleteTitle: string;
    figmaCompletionCompleteText: string;
    figmaSavingMediaText: string;
    conjointCardsText: string;
    conjointCompleteText: string;
    // Квота по варианту ответа набрана: вариант скрывается, показываем ошибку валидации
    quotaAnswersHideText: string;
}

export const initialSurveyAddonAlert: Readonly<SurveyAddonAlert> = {
    yourAnswer: 'Заполните поле "Свой ответ"',
    required: 'Этот вопрос нельзя оставить без ответа 👇',
    amount: 'Необходимо ответов: min: {min}, max: {max}',
    matrixAmount: 'Необходимо ответов в каждой строке: min: {min}, max: {max}',
    numRange: 'Пожалуйста, введите число от {min} до {max}',
    fileMaxSize: 'Максимальный размер файла {max}',
    fileExt: 'Файл имеет недопустимый формат. Возможно загрузить файлы с расширениями: {formats}',
    fileMaxAmount: 'Максимальное количество файлов = {count}',
    comment: 'Комментарий к вопросу обязательный для заполнения',
    email: 'Неверный формат',
    datetime: 'Неверный формат',
    distribution: 'Распределите все {points} баллов',
    phone: 'Неверный формат',
    indicator: 'осталось заполнить',
    inputTextLength: 'Необходимо символов: min: {min}, max: {max}',
    firstClickImage: 'Показать изображение',
    cardSortingCardsText: 'Карточки',
    cardSortingText: 'Перетащите сюда, чтобы добавить в категорию',
    cardSortingNewCategoryText: 'Перетащите сюда, чтобы создать новую категорию',
    cardSortedText: 'Все карточки отсортированы',
    cardSortingCategoryNameText: 'Введите название категории',
    cardSortingNoCategoryAvailableText: 'Нет доступных категорий',
    cardSortingNoCardsText: 'Нет карточек для сортировки',
    pairComparisonPairsText: 'Пары',
    pairComparisonCompleteText: 'Отлично, вы сравнили все пары 😊',
    maxDiffBlock: 'Блок',
    kanoRow: 'Функция',
    videoTestText: 'Для перехода далее необходимо досмотреть видео до конца',
    fiveSecTestImageText: 'Показать изображение',
    fiveSecTestText: 'Для перехода далее необходимо посмотреть изображение',
    figmaLoadingText: 'Загрузка теста...',
    figmaErrorText: 'Ошибка загрузки теста',
    figmaNoDataText: 'Нет данных для теста',
    figmaScreenNotFoundText: 'Экран не найден',
    figmaPrototypeUnavailableText: 'Прототип Figma недоступен для прохождения',
    figmaStartTitle: 'Готовы начать?',
    figmaStartInstruction: 'Нажмите «Начать», чтобы приступить к заданию.',
    figmaStartInstructionScreen:
        'Для прохождения задания нам нужно записать экран. Нажмите «Начать» и разрешите доступ к записи экрана.',
    figmaStartInstructionAudio:
        'Для прохождения задания нам нужно записать аудио. Нажмите «Начать» и разрешите доступ к микрофону.',
    figmaStartInstructionCamera:
        'Для прохождения задания нам нужно записать видео с камеры. Нажмите «Начать» и разрешите доступ к камере.',
    figmaStartInstructionScreenAudio:
        'Для прохождения задания нам нужно записать экран и аудио. Нажмите «Начать» и разрешите доступ к записи экрана и микрофону.',
    figmaStartInstructionScreenCamera:
        'Для прохождения задания нам нужно записать экран и видео с камеры. Нажмите «Начать» и разрешите доступ к записи экрана и камере.',
    figmaStartInstructionAudioCamera:
        'Для прохождения задания нам нужно записать аудио и видео с камеры. Нажмите «Начать» и разрешите доступ к микрофону и камере.',
    figmaStartInstructionScreenAudioCamera:
        'Для прохождения задания нам нужно записать экран, аудио и видео с камеры. Нажмите «Начать» и разрешите доступ к записи экрана, микрофону и камере.',
    figmaStartButton: 'Начать',
    figmaStartButtonRequesting: 'Получение разрешений...',
    figmaPermissionsError:
        'Не удалось получить разрешение на запись. Для продолжения необходимо разрешить доступ к выбранным устройствам.',
    figmaPermissionsManualText:
        'Если диалог запроса не появился, разрешите доступ в настройках браузера и нажмите «Начать» ещё раз.',
    figmaTimerLabel: 'Осталось',
    figmaSurrenderButton: 'Сдаюсь',
    figmaCompleteButton: 'Завершить',
    figmaCompletionSuccessTitle: 'Конец',
    figmaCompletionSuccessText: 'Вы успешно завершили задание',
    figmaCompletionSurrenderTitle: 'Задание завершено',
    figmaCompletionSurrenderText: 'Вы сдались',
    figmaCompletionTimeoutTitle: 'Время вышло',
    figmaCompletionTimeoutText: 'Задание завершено',
    figmaCompletionCompleteTitle: 'Задание завершено',
    figmaCompletionCompleteText: 'Вы завершили задание',
    figmaSavingMediaText: 'Файлы записей отправляются...',
    conjointCardsText: 'Карточки',
    conjointCompleteText: 'Отлично, вы выбрали все карточки 😊',
    quotaAnswersHideText: 'Квота по выбранному варианту ответа уже набрана. Пожалуйста, выберите другой ответ.',
};
